import { getSelectSchool } from '@/http/modules/baseSet/school'
import { AllStation } from '@/http/modules/baseSet/station'
import { getSelectSubject } from '@/http/modules/baseSet/major'
import { getSelectPlanFn } from '@/http/modules/examSet/examBatch'
import { getExamCheckStateFn } from '@/http/modules/examSet/score'
const state = () => ({
    selectSchoolFromStore: [],
    selectStationFromStore: [],
    selectSubjectFromStore: [],
    selectPlanFromStore: [],
    selectExamSignFromStore: [], // 考试转态标记
})

// getters
const getters = {}

// actions
const actions = {
    getSelectSchoolAction({ commit }) {
        return new Promise(resolve => {
            getSelectSchool().then(({ data }) => {
                commit('setSelectSchool', data)
                resolve(data)
            })
        })
    },
    getSelectStationAction({ commit }) {
        return new Promise(resolve => {
            AllStation().then(({ data }) => {
                commit('setSelectStation', data)
                resolve(data)
            })
        })
    },
    getSelectSubjectAction({ commit }) {
        return new Promise(resolve => {
            getSelectSubject().then(({ data }) => {
                commit('setSelectSubject', data)
                resolve(data)
            })
        })
    },
    getSelectPlanAction({ commit }) {
        return new Promise(resolve => {
            getSelectPlanFn().then(({ data }) => {
                commit('setSelectPlan', data)
                resolve(data)
            })
        })
    },
    getSelectExamSignAction({ commit }) {
        return new Promise(resolve => {
            getExamCheckStateFn().then(({ data }) => {
                commit('setselectExamSign', data)
                resolve(data)
            })
        })
    }
}

// mutations
const mutations = {
    setSelectSchool(state, data) {
        state.selectSchoolFromStore = data
    },
    setSelectStation(state, data) {
        state.selectStationFromStore = data
    },
    setSelectSubject(state, data) {
        state.selectSubjectFromStore = data
    },
    setSelectPlan(state, data) {
        state.selectPlanFromStore = data
    },
    setselectExamSign(state, data) {
        state.selectExamSignFromStore = data
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
